import {
  init_bakedVertexAnimation,
  init_bakedVertexAnimationDeclaration
} from "./chunk-U2CGTWSK.mjs";
import {
  init_morphTargetsVertexGlobalDeclaration
} from "./chunk-2FJ3SC63.mjs";
import {
  init_morphTargetsVertexDeclaration
} from "./chunk-4PCTWAWH.mjs";
import {
  init_morphTargetsVertexGlobal
} from "./chunk-BVA5OXBT.mjs";
import {
  init_morphTargetsVertex
} from "./chunk-MJBB3N4H.mjs";
import {
  init_bonesVertex
} from "./chunk-LVI2GRRT.mjs";
import {
  init_bonesDeclaration
} from "./chunk-UYBTZN7H.mjs";
import {
  BindBonesParameters,
  BindMorphTargetParameters,
  PrepareAttributesForBakedVertexAnimation,
  extractMinAndMax,
  init_materialHelper_functions,
  init_math_functions
} from "./chunk-VNR7RBTM.mjs";
import {
  Buffer,
  VertexBuffer,
  init_buffer
} from "./chunk-VK4AKGHS.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  Vector3,
  init_math_vector
} from "./chunk-KXFHISWH.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/gpuTransform.vertex.js
var name, shader;
var init_gpuTransform_vertex = __esm({
  "node_modules/@babylonjs/core/Shaders/gpuTransform.vertex.js"() {
    "use strict";
    init_shaderStore();
    init_bonesDeclaration();
    init_bakedVertexAnimationDeclaration();
    init_morphTargetsVertexGlobalDeclaration();
    init_morphTargetsVertexDeclaration();
    init_morphTargetsVertexGlobal();
    init_morphTargetsVertex();
    init_bonesVertex();
    init_bakedVertexAnimation();
    name = "gpuTransformVertexShader";
    shader = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
out vec3 outPosition;const mat4 identity=mat4(
vec4(1.0,0.0,0.0,0.0),
vec4(0.0,1.0,0.0,0.0),
vec4(0.0,0.0,1.0,0.0),
vec4(0.0,0.0,0.0,1.0)
);void main(void) {vec3 positionUpdated=position;
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
mat4 finalWorld=identity;
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);outPosition=worldPos.xyz;}`;
    ShaderStore.ShadersStore[name] = shader;
  }
});

// node_modules/@babylonjs/core/Shaders/gpuTransform.fragment.js
var name2, shader2;
var init_gpuTransform_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/gpuTransform.fragment.js"() {
    "use strict";
    init_shaderStore();
    name2 = "gpuTransformPixelShader";
    shader2 = `#version 300 es
void main() {discard;}
`;
    ShaderStore.ShadersStore[name2] = shader2;
  }
});

// node_modules/@babylonjs/core/Culling/Helper/transformFeedbackBoundingHelper.js
var TransformFeedbackBoundingHelper;
var init_transformFeedbackBoundingHelper = __esm({
  "node_modules/@babylonjs/core/Culling/Helper/transformFeedbackBoundingHelper.js"() {
    init_buffer();
    init_materialHelper_functions();
    init_math_functions();
    init_math_vector();
    init_gpuTransform_vertex();
    init_gpuTransform_fragment();
    TransformFeedbackBoundingHelper = class _TransformFeedbackBoundingHelper {
      /**
       * Creates a new TransformFeedbackBoundingHelper
       * @param engine defines the engine to use
       */
      constructor(engine) {
        this._buffers = {};
        this._effects = {};
        this._meshListCounter = 0;
        this._engine = engine;
      }
      /** @internal */
      processAsync(meshes) {
        if (!Array.isArray(meshes)) {
          meshes = [meshes];
        }
        this._meshListCounter = 0;
        this._processMeshList(meshes);
        return Promise.resolve();
      }
      _processMeshList(meshes) {
        const parallelShaderCompile = this._engine.getCaps().parallelShaderCompile;
        this._engine.getCaps().parallelShaderCompile = void 0;
        for (let i = 0; i < meshes.length; ++i) {
          const mesh = meshes[i];
          const vertexCount = mesh.getTotalVertices();
          if (vertexCount === 0 || !mesh.getVertexBuffer || !mesh.getVertexBuffer(VertexBuffer.PositionKind)) {
            continue;
          }
          let computeEffect;
          let numInfluencers = 0;
          const defines = [];
          let uniforms = [];
          const attribs = [VertexBuffer.PositionKind];
          const samplers = [];
          if (mesh && mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
            attribs.push(VertexBuffer.MatricesIndicesKind);
            attribs.push(VertexBuffer.MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
              attribs.push(VertexBuffer.MatricesIndicesExtraKind);
              attribs.push(VertexBuffer.MatricesWeightsExtraKind);
            }
            const skeleton = mesh.skeleton;
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            if (skeleton.isUsingTextureForMatrices) {
              defines.push("#define BONETEXTURE");
              if (uniforms.indexOf("boneTextureWidth") === -1) {
                uniforms.push("boneTextureWidth");
              }
              if (samplers.indexOf("boneSampler") === -1) {
                samplers.push("boneSampler");
              }
            } else {
              defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
              if (uniforms.indexOf("mBones") === -1) {
                uniforms.push("mBones");
              }
            }
          } else {
            defines.push("#define NUM_BONE_INFLUENCERS 0");
          }
          const manager = mesh ? mesh.morphTargetManager : null;
          if (manager) {
            numInfluencers = manager.numMaxInfluencers || manager.numInfluencers;
            if (numInfluencers > 0) {
              defines.push("#define MORPHTARGETS");
            }
            if (manager.isUsingTextureForTargets) {
              defines.push("#define MORPHTARGETS_TEXTURE");
              if (uniforms.indexOf("morphTargetTextureIndices") === -1) {
                uniforms.push("morphTargetTextureIndices");
              }
              if (samplers.indexOf("morphTargets") === -1) {
                samplers.push("morphTargets");
              }
            }
            defines.push("#define NUM_MORPH_INFLUENCERS " + numInfluencers);
            for (let index = 0; index < numInfluencers; index++) {
              attribs.push(VertexBuffer.PositionKind + index);
            }
            if (numInfluencers > 0) {
              uniforms = uniforms.slice();
              uniforms.push("morphTargetInfluences");
              uniforms.push("morphTargetCount");
              uniforms.push("morphTargetTextureInfo");
              uniforms.push("morphTargetTextureIndices");
            }
          }
          const bvaManager = mesh.bakedVertexAnimationManager;
          if (bvaManager && bvaManager.isEnabled) {
            defines.push("#define BAKED_VERTEX_ANIMATION_TEXTURE");
            if (uniforms.indexOf("bakedVertexAnimationSettings") === -1) {
              uniforms.push("bakedVertexAnimationSettings");
            }
            if (uniforms.indexOf("bakedVertexAnimationTextureSizeInverted") === -1) {
              uniforms.push("bakedVertexAnimationTextureSizeInverted");
            }
            if (uniforms.indexOf("bakedVertexAnimationTime") === -1) {
              uniforms.push("bakedVertexAnimationTime");
            }
            if (samplers.indexOf("bakedVertexAnimationTexture") === -1) {
              samplers.push("bakedVertexAnimationTexture");
            }
            PrepareAttributesForBakedVertexAnimation(attribs, mesh, defines);
          }
          const join = defines.join("\n");
          if (!this._effects[join]) {
            const computeEffectOptions = {
              attributes: attribs,
              uniformsNames: uniforms,
              uniformBuffersNames: [],
              samplers,
              defines: join,
              fallbacks: null,
              onCompiled: null,
              onError: null,
              indexParameters: { maxSimultaneousMorphTargets: numInfluencers },
              maxSimultaneousLights: 0,
              transformFeedbackVaryings: ["outPosition"]
            };
            computeEffect = this._engine.createEffect("gpuTransform", computeEffectOptions, this._engine);
            this._effects[join] = computeEffect;
          } else {
            computeEffect = this._effects[join];
          }
          this._compute(mesh, computeEffect);
        }
        this._engine.getCaps().parallelShaderCompile = parallelShaderCompile;
      }
      _compute(mesh, effect) {
        var _a;
        const engine = this._engine;
        let targetBuffer;
        const vertexCount = mesh.getTotalVertices();
        if (!this._buffers[mesh.uniqueId]) {
          const targetData = new Float32Array(vertexCount * 3);
          targetBuffer = new Buffer(mesh.getEngine(), targetData, true, 3);
          this._buffers[mesh.uniqueId] = targetBuffer;
        } else {
          targetBuffer = this._buffers[mesh.uniqueId];
        }
        effect.getEngine().enableEffect(effect);
        mesh._bindDirect(effect, null, true);
        BindBonesParameters(mesh, effect);
        const manager = mesh.morphTargetManager;
        if (manager && manager.numInfluencers > 0) {
          BindMorphTargetParameters(mesh, effect);
        }
        const bvaManager = mesh.bakedVertexAnimationManager;
        if (bvaManager && bvaManager.isEnabled) {
          (_a = mesh.bakedVertexAnimationManager) == null ? void 0 : _a.bind(effect, false);
        }
        const arrayBuffer = targetBuffer.getData();
        engine.bindTransformFeedbackBuffer(targetBuffer.getBuffer());
        engine.setRasterizerState(false);
        engine.beginTransformFeedback(true);
        engine.drawArraysType(2, 0, vertexCount);
        engine.endTransformFeedback();
        engine.setRasterizerState(true);
        engine.readTransformFeedbackBuffer(arrayBuffer);
        engine.bindTransformFeedbackBuffer(null);
        if (this._meshListCounter === 0) {
          mesh._refreshBoundingInfo(arrayBuffer, null);
        } else {
          const bb = mesh.getBoundingInfo().boundingBox;
          const extend = extractMinAndMax(arrayBuffer, 0, vertexCount);
          _TransformFeedbackBoundingHelper._Min.copyFrom(bb.minimum).minimizeInPlace(extend.minimum);
          _TransformFeedbackBoundingHelper._Max.copyFrom(bb.maximum).maximizeInPlace(extend.maximum);
          mesh._refreshBoundingInfoDirect({ minimum: _TransformFeedbackBoundingHelper._Min, maximum: _TransformFeedbackBoundingHelper._Max });
        }
      }
      /** @internal */
      registerMeshListAsync(meshes) {
        if (!Array.isArray(meshes)) {
          meshes = [meshes];
        }
        this._meshList = meshes;
        this._meshListCounter = 0;
        return Promise.resolve();
      }
      /** @internal */
      processMeshList() {
        if (this._meshList.length === 0) {
          return;
        }
        this._processMeshList(this._meshList);
        this._meshListCounter++;
      }
      /** @internal */
      fetchResultsForMeshListAsync() {
        this._meshListCounter = 0;
        return Promise.resolve();
      }
      /** @internal */
      dispose() {
        for (const key in this._buffers) {
          this._buffers[key].dispose();
        }
        this._buffers = {};
        this._effects = {};
        this._engine = null;
      }
    };
    TransformFeedbackBoundingHelper._Min = new Vector3();
    TransformFeedbackBoundingHelper._Max = new Vector3();
  }
});

export {
  TransformFeedbackBoundingHelper,
  init_transformFeedbackBoundingHelper
};
